import React from 'react'
import { Button, useColorMode } from '@chakra-ui/react'
import { getTokens } from '../../config/colorTokens'

const SkillButton = (props) => {
    const { colorMode } = useColorMode()
    const t = getTokens(colorMode)

    return (
        <Button
            border="1px"
            borderRadius="8px"
            size="sm"
            h="34px"
            px={3}
            borderColor={t.borderSubtle}
            bg={t.surfaceAlpha}
            color={t.textSecondary}
            fontWeight="medium"
            iconSpacing={2}
            transition="all 0.2s ease"
            _hover={{
                textDecoration: "none",
                bg: t.hoverBg,
                borderColor: props.color,
                color: props.color,
                transform: "translateY(-1px)"
            }}
            _active={{
                transform: "translateY(0)"
            }}
            leftIcon={props.icon}
        >
            {props.text}
        </Button>
    )
}

export default SkillButton
